import "./content/assets/oceanic-next.css"
